export const DESTINATIONS = [
  {
    key: "phillip-island",
    name: "Phillip Island",
    image: "/images/phillip-island/Philip island.jpeg",
    blurb: "Penguins, beaches and coastal drives",
    location: "Victoria · Australia",
  },
  {
    key: "mornington-peninsula",
    name: "Mornington Peninsula",
    image: "/images/mornington-peninsula/mornington peninsula.jpeg",
    blurb: "Wineries, hot springs and seaside towns",
    location: "Victoria · Australia",
  },
  {
    key: "wilsons-prom",
    name: "Wilsons Promontory",
    image: "/images/wilsons-prom/wilsons prom.jpg",
    blurb: "National park hikes and pristine beaches",
    location: "Victoria · Australia",
  },
  {
    key: "mount-buller",
    name: "Mount Buller",
    image: "/images/mount-buller/Mount buller.jpg.webp",
    blurb: "Snow in winter, alpine trails in summer",
    location: "Victoria · Australia",
  },
  {
    key: "great-ocean-road",
    name: "Great Ocean Road",
    image: "/images/great-ocean-road/Great ocean road.jpg",
    blurb: "Dramatic cliffs, ancient rainforests and the Twelve Apostles",
    location: "Victoria · Australia",
  },
  {
    key: "yarra-valley",
    name: "Yarra Valley",
    image: "/images/yarra-valley/Yarra valley.jpg",
    blurb: "Rolling vineyards, farm gates and misty mountain views",
    location: "Victoria · Australia",
  },
  {
    key: "sydney",
    name: "Sydney",
    image: "/images/sydney/Sydney.avif",
    blurb: "Iconic harbour, golden beaches and world-class dining",
    location: "New South Wales · Australia",
  },
  {
    key: "adelaide",
    name: "Adelaide",
    image: "/images/adelaide/Adelaide.jpeg",
    blurb: "Wine country, laneways and laid-back coastal charm",
    location: "South Australia · Australia",
  },
];

// Helper function to get destination by key
export const getDestinationByKey = (key) => {
  return DESTINATIONS.find(dest => dest.key === key);
};

// Helper function to get destination image by key
export const getDestinationImage = (key) => {
  const destination = getDestinationByKey(key);
  return destination ? destination.image : "https://via.placeholder.com/600x320?text=Destination";
};
